<template>
  <div id="app">
    <GlobalOverlay v-if="initialNavigationPending" class="boot-loader">
      <n-loading dark size="l" />
    </GlobalOverlay>
    <NavigationProgressBar />
    <router-view />
    <NConfirmModalProvider />
    <NSnackbarProvider />
    <UpgradeFeatureModalProvider />
    <VariableAssignmentProvider />
    <TableSlashSizePicker />
    <portal-target name="modal" multiple />
    <portal-target name="dropdown" multiple />
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { NSnackbarProvider } from '@/modules/global/components/core/NSnackbar'
import NConfirmModalProvider from '@/modules/global/components/core/NConfirmModal/NConfirmModalProvider.vue'
import UpgradeFeatureModalProvider from '@/modules/featurerestriction/components/UpgradeFeatureModalProvider.vue'
import NavigationProgressBar from '@/modules/global/components/NavigationProgressBar.vue'
import GlobalOverlay from '@/modules/global/components/GlobalOverlay.vue'
import VariableAssignmentProvider from '@/modules/global/components/VariableAssignmentProvider.vue'
import TableSlashSizePicker from '@/modules/elements/components/table/TableSlashSizePicker.vue'

@Component({
  components: {
    VariableAssignmentProvider,
    TableSlashSizePicker,
    NavigationProgressBar,
    GlobalOverlay,
    UpgradeFeatureModalProvider,
    NConfirmModalProvider,
    NSnackbarProvider
  }
})
export default class App extends Vue {
  /**
   * The first navigation awaits the network (tokenCheckGuard, the lazy view chunk) after the app has mounted, and the
   * router-view renders nothing until it resolves: on a slow connection that was a long blank page. Keep the same
   * spinner as index.html's boot loader and Framework up until then. NavigationProgressBar cannot cover this: it is
   * created after the first navigation has already started.
   */
  private initialNavigationPending = true

  created() {
    const settle = () => (this.initialNavigationPending = false)
    this.$router.onReady(settle, settle)
  }
}
</script>
